import angular from 'angular';
import {applyFilters, filterOptions, toggleFilter} from '../charts/boardFilters.js';

/** The boards' Filters dialog: locals rows, categories, selection; resolves with the new selection. */
export default function BoardFiltersDialogCtrl($scope, $mdDialog, rows, categories, selection) {
  // The picks are a draft until "Show N results": closing the dialog leaves the board as it was.
  let draft = {...selection};
  $scope.categories = categories;
  $scope.current = categories[0].key;

  // The template only reads fields, so everything it shows is worked out here on each change.
  function refresh() {
    const category = categories.find(c => c.key === $scope.current);
    $scope.title = category.title;
    $scope.options = filterOptions(rows, category, draft, categories)
      .map(o => ({...o, on: (draft[category.key] || []).includes(o.key)}));
    $scope.picks = Object.fromEntries(categories.map(c => [c.key, (draft[c.key] || []).length]));
    $scope.results = applyFilters(rows, draft, categories).length;
  }

  $scope.choose = key => { $scope.current = key; refresh(); };
  $scope.toggle = key => { draft = toggleFilter(draft, $scope.current, key); refresh(); };
  $scope.clear = () => { draft = {}; refresh(); };
  $scope.show = () => $mdDialog.hide(draft);
  $scope.close = () => $mdDialog.cancel();

  refresh();
}

/**
 * Opens the dialog over a board. Its promise resolves with the selection "Show N results" leaves,
 * and is rejected when the dialog is closed any other way.
 * @param locals {rows, categories, selection}
 */
export function showBoardFilters($mdDialog, $mdMedia, ev, locals) {
  return $mdDialog.show({
    controller: 'BoardFiltersDialogCtrl',
    template: require('../views/board-filters-dialog.html'),
    parent: angular.element(document.body),
    targetEvent: ev,
    clickOutsideToClose: true,
    fullscreen: $mdMedia('xs'),
    locals: locals
  });
}
